import { useQuery } from 'react-query';

import { fetchStatusPageSummary } from './fetchStatusPageSummary';
import { StatusPageSummaryResponse } from './types';

const STATUS_PAGE_SUMMARY_QUERY_KEY = ['status-page-summary'];

/**
 * Polls the public Statuspage summary API while the status banner feature is enabled.
 */
export function useStatusPageSummary(enabled: boolean) {
  return useQuery<StatusPageSummaryResponse, Error>(STATUS_PAGE_SUMMARY_QUERY_KEY, fetchStatusPageSummary, {
    enabled,
    // Statuspage rate-limits to ~1 req/sec/IP; five minutes matches prior embed refresh cadence.
    refetchInterval: 5 * 60 * 1000,
    staleTime: 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
